import BossModel from "@/models/BossModel";
import PersonalDetail from "@/models/WebsiteOffer/PersonalDetail";
import Proposal from "@/models/Proposal/Proposal";
import Product from "@/models/Product/Product";

export default class TourRequest extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-offer/tour-request';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteOfferTourRequests';

    static fields() {
        return {
            id: this.attr(null),
            website_offer_personal_detail_id: this.attr(null),
            start_date: this.attr(null),
            total_visible_price: this.attr(null),
            product_id: this.attr(null),
            created_at: this.attr(null),
            personal_detail: this.belongsTo(PersonalDetail, 'website_offer_personal_detail_id'),
            product: this.belongsTo(Product, 'product_id'),
        }
    }

    /**
     *
     * @param newProposal
     * @returns {Promise<Collections>}
     * @constructor
     */
    CreateProposal(newProposal) {
        return this.constructor.api().action(this.id + '/create-proposal')
            .create(newProposal, false).then((response) => {
                return Proposal.insert({data: response});
            });
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PersonalDetail() {
        return this.getRelated('personal_detail');
    }
}
